import { required, optional, array, obj } from 'AppReact/schema';
import { checklistItem } from './checklistItem';

export default {
  assigned_to: optional('string'),
  completed_by: optional('string'),
  created_by: required('string'),
  creation_date: required('jsDate'),
  completion_date: optional('jsDate'),
  id: required('integer'),
  items: array(obj(checklistItem)),
  property_name: required('string'),
  status: required('string'),
  name: required('string'),
  unit: optional('string'),
}

export const defaultChecklist = {
  assigned_to: null,
  completed_by: null,
  completion_date: null,
  created_by: 'Talha Majid',
  creation_date: new Date(),
  id: 2,
  property_name: 'Alera West',
  status: 'open',
  name: 'Test checklist',
  unit: null,
  items: [
    {
      name: 'test1',
      description: 'test description1',
      checklist_id: 11,
      request_id: 12,
      is_complete: true,
      events: [],
    },
    {
      name: 'test2',
      description: 'test description2',
      checklist_id: 11,
      request_id: 12,
      is_complete: true,
      events: [],
    },
    {
      name: 'test3',
      description: 'test description3',
      checklist_id: 11,
      request_id: 12,
      is_complete: false,
      events: [],
    },
  ]
}